import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
// import Footer from "./components/Footer";
import Footer from "./DynamicFooter";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import AdminDashboard from "./pages/AdminDashboard";
import PaymentBatchesPage from "./pages/PaymentBatchesPage";
import BatchDetailsPage from "./pages/BatchDetailsPage";

import Dashboard from "./pages/Dashboard";
import EditProfile from "./pages/EditProfile";
import AddStore from "./pages/AddStore";
import Orders from "./components/Orders/Orders";
import ProductGroups from "./components/ProductGroups/ProductGroups";
import EditProductGroup from "./components/ProductGroups/EditProductGroup";
import { SkeletonTheme } from "react-loading-skeleton";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useHideTemplateHeader from "./hooks/useHideTemplateHeader";
// import Home from "./pages/Home";
import LandingPage from "./DynamicLandingPage";
// import PublicNavbar from "./components/Navbar/PublicNavbar";
import PublicNavbar from "./DyanmicHeader";
import ResetPassword from "./pages/ResetPassword";
import ForgotPassword from "./pages/ForgotPassword";
import StorePayoutsPage from "./components/StorePayments/StorePayoutsPage";
import TransactionsPage from "./components/StorePayments/TransactionsPage";
import EditPaymentSettingsPage from "./components/StorePayments/EditPaymentSettingsPage";

const App: React.FC = () => {
  const [modules, setModules] = useState<
    { id: number; title: string; url: string }[]
  >([]);
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const location = useLocation();
  useEffect(() => {
    const user = localStorage.getItem("user");
    const token = localStorage.getItem("token");

    if (user && token) {
      const parsedUser = JSON.parse(user);
      setModules(parsedUser.modules);
      setIsLoggedIn(true);
    }
    setIsLoading(false);
  }, []);

  const handleLogin = (
    userModules: { id: number; title: string; url: string }[]
  ) => {
    setIsLoggedIn(true);
    setModules(userModules);
  };

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
  };

  /*const hasAccessToModule = (moduleName: string) => {
    const canViewModule = !!JSON.parse(localStorage.getItem("user") || '{}')?.modules?.find((m: any) => m.title === moduleName)?.ModulesPermissions?.view;
    return canViewModule;
  };*/

  function capitalize(str: string = ""): string {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  const currentRole = JSON.parse(localStorage.getItem("user") || '{}').current_role;
  const currentRoleTitle = capitalize(((JSON.parse(localStorage.getItem("user") || '{}')?.roles?.[0]?.role_name) || ''));
  document.title = "My Kix Store - " + currentRoleTitle;

  const DefaultDashboard = () => {
    if (isLoading) {
      return null;
    }

    if (!isLoggedIn) {
      return <LandingPage />;
    }

    return currentRole === 1 || currentRole === 8 ? (
      <Navigate to="/admin-dashboard" replace />
    ) : (
      <Navigate to="/dashboard" replace />
    );
  };

  const hideTemplateHeader = useHideTemplateHeader([]);

  return (
    <SkeletonTheme baseColor="#e5d3e7" highlightColor="#e0e0e0">
      <div className="app-container">
        {["/login", "/signup", "/reset-password", "/forgot-password"].includes(location.pathname) || (!isLoggedIn && location.pathname === "/") ? (
  <PublicNavbar />
) : (
  isLoggedIn && !hideTemplateHeader && (
    <Navbar
      isLoggedIn={isLoggedIn}
      handleLogout={handleLogout}
      modules={modules}
    />
  )
)}
        <div className="content">
          <Routes>

            <Route path="/" element={<DefaultDashboard />} />
            <Route path="/login" element={<Login onLogin={handleLogin} />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            {/* Admin dashboard */}
            {isLoggedIn && (currentRole == 1) && (
              <Route path="/admin-dashboard/" element={<AdminDashboard />} />
            )}
            {isLoggedIn && (currentRole == 1) && (
              <Route path="/payment-batches" element={<PaymentBatchesPage />} />
            )}
            {isLoggedIn && (currentRole == 1) && (
              <Route path="/payment-batches/:batch_id" element={<BatchDetailsPage />} />
            )}
            {isLoggedIn && (currentRole == 1) ? (
              <Route path="/add-store/" element={<Signup />} />
            ): (
              <Route path="/add-store/" element={<AddStore />} />
            )}
            {isLoggedIn && (currentRole != 1) && (
              <Route path="/add-store/" element={<AddStore />} />
            )}
            {isLoggedIn && (
              <Route path="/edit-store/:store_id" element={<EditProfile />} />
            )}
            {isLoggedIn && (currentRole == 1) && (
              <Route path="/edit-store-owner/:store_id" element={<EditProfile />} />
            )}

            

            {/* User dashboard */}
            {isLoggedIn && (
              <Route path="/dashboard/*" element={<Dashboard />} />
            )}
            {isLoggedIn && (
              <Route path="/orders" element={<Orders />} />
            )}
            {isLoggedIn && (
              <Route path="/orders/:store_id" element={<Orders />} />
            )}

            {isLoggedIn && (currentRole == 1) && (
              <Route path="/payouts/:store_id" element={<StorePayoutsPage />} />
            )}

            {isLoggedIn && (currentRole == 1 || currentRole == 2) && (
              <Route path="/payouts-settings/edit/:store_id" element={<EditPaymentSettingsPage />} />
            )}

            {isLoggedIn && currentRole == 2 && (
              <Route path="/payouts/:store_id" element={<TransactionsPage />} />
            )}

            {isLoggedIn && (
              <Route path="/product-groups/:store_id" element={<ProductGroups />} />
            )}

            {isLoggedIn && (
              <Route path="/product-groups/add" element={<EditProductGroup />} />
            )}

            {isLoggedIn && (
              <Route path="/product-groups/edit/:collection_id" element={<EditProductGroup />} />
            )}

            {/* Edit profile */}
            {isLoggedIn && (
              <Route path="/edit-profile" element={<EditProfile />} />
            )}

            <Route
              path="*"
              element={
                localStorage.getItem("token") ? (<section></section>) : (
                  <Navigate to="/login" replace />
                )
              }
            />

          </Routes>
          <ToastContainer
            className="custom-toast-info"
            position="top-right"
            autoClose={7000}
            hideProgressBar={false}
            closeOnClick={true}
            pauseOnHover={true}
            draggable={true}
            theme="light"
          />
        </div>
        {!isLoggedIn && !["/login", "/signup", "/reset-password", "/forgot-password"].includes(location.pathname) && <Footer />}
      </div>
    </SkeletonTheme>
  );
};

const AppWrapper: React.FC = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;
